import { PixelRatio, Platform } from 'react-native';
export const getSizeBasedOnFontScale = (size) => Platform.select({
    native: Math.ceil(PixelRatio.getFontScale() * size),
    default: size,
});
//# sourceMappingURL=common.js.map